import { type FunctionComponent, } from "react";
import { n, bi, } from "../../helpers";

export declare type WEIProps = {
	/** value to be rendered. */
	value: BigInt | undefined;

	/** decimal precision */
	points?: number;

	/** a label that will prelude the value */
	label?: string;

	loading?: boolean;
};



export const WEI: FunctionComponent<WEIProps> = ({
	label,
	value,
	points = 5,
	loading,
}) => {

	typeof loading === undefined ? typeof value !== "bigint" : loading;
	const classes = [ `wei`, ].join(" ");
	const getValue = () => {
		if(loading) return "loading...";
		return typeof value === "bigint" ? n(value).toFixed(points) : "invalid";
	}

	return (
		<span className={classes}>
			{ label && <span className="label">{label}</span> }
			<span className="value">{getValue()}</span>
		</span>
	);
};
